import type { ComponentProps } from "react";
import type { ClerkProvider } from "@clerk/clerk-react";

type Appearance = NonNullable<ComponentProps<typeof ClerkProvider>["appearance"]>;

/** Brand styling for every Clerk surface (embedded forms, modal, user menu). */
export const clerkAppearance: Appearance = {
  variables: {
    colorPrimary: "#702f3a",
    colorText: "#2f2622",
    colorTextSecondary: "#7b7068",
    colorBackground: "#fffdf9",
    colorInputBackground: "#ffffff",
    colorInputText: "#2f2622",
    borderRadius: "0.4rem",
    fontFamily: "var(--font-family-body), system-ui, sans-serif",
  },
  elements: {
    headerTitle: {
      fontFamily: "var(--font-family-heading), Georgia, serif",
      fontWeight: 500,
      fontSize: "1.6rem",
      letterSpacing: "-0.02em",
    },
    formButtonPrimary: {
      fontWeight: 700,
      letterSpacing: "0.03em",
      textTransform: "none",
      boxShadow: "0 8px 18px rgba(78, 34, 40, 0.16)",
    },
    card: { boxShadow: "0 22px 50px rgba(55, 42, 34, 0.12)", border: "1px solid rgba(63, 45, 35, 0.08)" },
    footerActionLink: { color: "#702f3a", fontWeight: 700 },
  },
};
